import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit/logs").then((r) => setRows(r.data)); }, []);

  return (
    <div className="space-y-5 lb-fade" data-testid="audit-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Compliance</div>
        <h1 className="font-display font-extrabold text-3xl tracking-tight">Audit Logs</h1>
      </div>
      <div className="lb-card">
        <table className="lb-table">
          <thead><tr><th>Time</th><th>Action</th><th>Reference</th><th>Meta</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td className="text-sm font-mono">{fmtDate(r.created_at)}</td>
                <td className="font-semibold text-sm">{r.action}</td>
                <td className="font-mono text-xs">{r.ref}</td>
                <td className="text-xs text-neutral-500 font-mono">{JSON.stringify(r.meta)}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="text-center py-10 text-neutral-500">No logs</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
